let html = `<div class="discuss-rules">
    <div class="discuss-rules__body">
        <div class="discuss-rules__title">
            #{discuss_rules_title}
        </div>

        <div class="discuss-rules__items">
            <div>#{discuss_rules_rule_1}</div>
            <div>#{discuss_rules_rule_2}</div>
            <div>#{discuss_rules_rule_3}</div>
            <div>#{discuss_rules_rule_4}</div>
            <div>#{discuss_rules_rule_5}</div>
            <div>#{discuss_rules_rule_6}</div>
            <div>#{discuss_rules_rule_7}</div>
        </div>
    </div>
</div>`

export default html